<script setup lang="ts">
import type { AppLocale } from "@/i18n"
import { useLocale } from "@/i18n"

const { locale, setLocale } = useLocale()
const options: { value: AppLocale; label: string; name: string }[] = [
  { value: "ru", label: "РУ", name: "Russian" },
  { value: "en", label: "EN", name: "English" },
]
</script>

<template>
  <div class="locale-switcher" role="group" :aria-label="$t('Language')">
    <button v-for="option in options" :key="option.value" type="button" :class="{ active: locale === option.value }"
      :aria-label="$t(option.name)" :aria-pressed="locale === option.value" @click="setLocale(option.value)">
      {{ option.label }}
    </button>
  </div>
</template>
